import React from 'react';
import env from 'env';
import { Link, Redirect } from "react-router-dom";
import { usePost } from 'components';
import { useForm } from 'form';
import { Button, ErrorMessage } from 'components';

export function ProductEditForm({ model }) {
  const form = useForm(model, {});
  const post = usePost();

  const render = (name) => form.renderControl(name);

  function save(e) {
    form.validateForm(e, () => {
      const value = { ...form.getValue() };
      post.send(env.apiBase + "/api/productAdmin/createProduct", value);
    })
  }

  if (post.status === 'done') {
    console.log(post.response)
    const productCode = post.response.results.productCode;
    return <Redirect to={`/admin/product/edit/${productCode}`} />
  }

  return (
    <div className="editor productEditor">
      <h1>New Product</h1>

      <section>
        <div className="row">
          <div className="col-md-3">{render('productCode')}</div>
          <div className="col-md-3">{render('productStatus')}</div>
          <div className="col-md-3">{render('category')}</div>
        </div>
        <div className="row">
          <div className="col-12">{render('productName')}</div>
        </div>

        <div className="row">
          <div className="col-12 actions">
            <ErrorMessage errors={form.errors} />
            <ErrorMessage errors={post.errors} />
            <Button onClick={save} status={form.status}>Create</Button>
            <Link className="btn btn-outline-dark" to="/admin/products">Cancel</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
